import I18n from 'I18n';
import formatName from 'I18n/utils/formatName';
import { FormattedIntlCurrency } from 'I18n/components/FormattedIntlCurrency';
import Small from 'UIComponents/elements/Small';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default (invoicesResponseMap => {
  if (!invoicesResponseMap) return [];
  return invoicesResponseMap.results.map(invoice => {
    const invoiceDueDate = I18n.moment.userTz(+invoice.properties.hs_due_date.value).format('LL');
    const associatedContacts = invoice.associatedObjects.INVOICE_TO_CONTACT && invoice.associatedObjects.INVOICE_TO_CONTACT.map(contact => formatName({
      firstName: contact.properties.firstname && contact.properties.firstname.value,
      lastName: contact.properties.lastname && contact.properties.lastname.value,
      email: contact.properties.email && contact.properties.email.value
    })) || [];
    return {
      value: invoice.objectId,
      text: /*#__PURE__*/_jsxs("span", {
        children: [invoice.properties.hs_number.value, " |", ' ', /*#__PURE__*/_jsx(FormattedIntlCurrency, {
          currencyCode: invoice.properties.hs_currency.value,
          value: +invoice.properties.hs_amount_billed.value
        }), /*#__PURE__*/_jsx(Small, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            useGap: true,
            message: "hubspot-prosemirror.invoices.popover.results.details",
            options: {
              invoiceDueDate
            }
          })
        })]
      }),
      help: associatedContacts.length && /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.invoices.popover.results.to",
        options: {
          associatedContacts: associatedContacts.join(', ')
        }
      })
    };
  });
});